import { cn, Icon, Text } from "@flare/ui";

export const MessageBanner = ({
  children,
  variant,
  alignVertical,
  className,
}: {
  alignVertical?: boolean;
  children: string;
  className?: string;
  variant: "warning" | "danger";
}) => {
  return (
    <div
      className={cn(
        "flex w-full gap-sp-2 rounded-sm border-0 p-sp-3 md:pr-sp-5",
        { "items-center": alignVertical },
        { "bg-warning": variant === "warning" },
        { "bg-danger": variant === "danger" },
        className,
      )}
    >
      <div className="pt-sp-0_5">
        <Icon
          name="exclamation-circle"
          className={cn({
            "text-text-danger": variant === "danger",
          })}
        />
      </div>
      <Text variant="body2">{children}</Text>
    </div>
  );
};
